import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.1875 7.0625C15.2656 7.0625 15.3047 7.10156 15.3828 7.17969C15.4609 7.25781 15.5 7.29688 15.5 7.375V8.625C15.5 8.70312 15.4609 8.78125 15.3828 8.85938C15.3047 8.9375 15.2656 8.9375 15.1875 8.9375H8.9375V15.1875C8.9375 15.2656 8.89844 15.3438 8.82031 15.4219C8.74219 15.5 8.70312 15.5 8.625 15.5H7.375C7.29688 15.5 7.21875 15.5 7.14062 15.4219C7.0625 15.3438 7.0625 15.2656 7.0625 15.1875V8.9375H0.8125C0.734375 8.9375 0.65625 8.9375 0.578125 8.85938C0.5 8.78125 0.5 8.70312 0.5 8.625V7.375C0.5 7.29688 0.5 7.25781 0.578125 7.17969C0.65625 7.10156 0.734375 7.0625 0.8125 7.0625H7.0625V0.8125C7.0625 0.734375 7.0625 0.695312 7.14062 0.617188C7.21875 0.539062 7.29688 0.5 7.375 0.5H8.625C8.70312 0.5 8.74219 0.539062 8.82031 0.617188C8.89844 0.695312 8.9375 0.734375 8.9375 0.8125V7.0625H15.1875Z",
		fill: "currentColor"
	})
});
export default SvgPlus;
